import api from './api'

class InvoiceDataService {
    getSiteInvoicings(siteId) {
        return api.get(`/sites/${siteId}/invoicings`)
    }

    getAppAuthentication(code, state) {
        return api.get(`/app_authentication?code=${code}&state=${state}`)
    }

    getInvoicing(id) {
        return api.get(`/invoicings/${id}`)
    }

    getPreparedInvoices(id, appName) {
        return api.get(`/invoicings/${id}/prepared_invoices?app=${appName}`)
    }

    createInvoice(id, appName) {
        return api.post(`/invoice/${id}/create`, { app: appName })
    }

    uploadInvoices(data) {
        let formData = new FormData()

        formData.append('file', data.file)

        return api.post(`/sites/${data.siteId}/upload_invoices`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
    }

    deleteInvoicing(invoicingId) {
        return api.delete(`/invoicings/${invoicingId}`)
    }

    getInvoiceList(invoicingId) {
        return api.get(`/invoicings/${invoicingId}/list`)
    }
}

export default new InvoiceDataService()